import { createFileRoute } from '@tanstack/react-router';

import { FavoritesMobilePage } from '@/pages/pinned/favorites-mobile-page';
import { FavoritesPage } from '@/pages/pinned/favorites-page';
import { useMobile } from '@/shared/lib/use-mobile';

/**
 * Favorites (`/my/pinned`) — restored in v2.1 next to the sidebar section:
 * every pin grouped (tasks / projects / teams), reorder, remove, and the
 * rail to add a task, re-star a recently viewed one, or star a team or
 * project. The URL is the old Pinned page's, so bookmarks keep working.
 */
function FavoritesRoute() {
  const isMobile = useMobile();
  return isMobile ? <FavoritesMobilePage /> : <FavoritesPage />;
}

export const Route = createFileRoute('/my/pinned')({ component: FavoritesRoute });
